<template>
    <card>
        <card-body :class="title" @click.native.prevent="showUrl">
            <h5 class="card-title text-center"><b>{{ title | capitalize }}</b></h5>
        </card-body>
        <ul class="list-group list-group-flush"><a class="list-group-item small" :href="url" target="_blank">{{ url
            }}</a></ul>
    </card>
</template>

<script>
    export default {

        props: {
            title: {type: String},
            url: {type: String, required: true},
        },

        data: () => ({
            isActive: false
        }),

        computed: {
            titleClass() {
                return this.isActive ? `${this.title}` : null;
            }
        },

        methods: {
            showUrl() {
                this.isActive = !this.isActive;
            }
        }

    };
</script>

<style lang="scss" scoped>
    .yelp {
        background-color: #9f191f;
    }

    .google {
        background-color: #ea4335;
    }

    .facebook {
        background-color: #4267b2;
    }

    .trip_advisor {
        background-color: #83bd56;
    }

    .capterra {
        background-color: #1171B8;
    }

    .software_advice {
        background-color: #ff9b34;
    }

    .g2_crowd {
        background-color: #02080b;
    }

    .golf_now {
        background-color: #558e2e;
    }

    .yelp h5,
    .google h5,
    .facebook h5,
    .trip_advisor h5,
    .capterra h5,
    .software_advice h5,
    .g2_crowd h5,
    .golf_now h5 {
        color: #fff;
        font-weight: bold;
    }

</style>
